import Task from "../task";

export function taskDebugGantt(task:Task) {


    const dependencyDates = task.datesForDependency

    // @ts-ignore
    console.purple(task.debugName)
    // @ts-ignore
    console.print("Start/End", task.startDate, task.endDate)
    // @ts-ignore
    console.print("DISPLAY: ", task.displayStartDate, task.displayEndDate)
    // @ts-ignore
    console.print("DEPENDENCY: ", dependencyDates.start, dependencyDates.end)
    // @ts-ignore
    console.print("SCHEDULE:", task.scheduleDate)
    // console.log("CHILDREN: ", task.childrenItems)

}